import React, { forwardRef } from "react";
import { Button as RadixButton } from "@radix-ui/themes";
import styles from "./styles.module.scss";

const Button = forwardRef(({ 
  children, 
  onClick, 
  variant = "normal", 
  size = "3", 
  className = "",
  backgroundColor = "var(--color-primary)",
  textColor = "var(--color-secondary)",
  ...props 
}, ref) => {
  const variantClass = variant === "outlined" 
    ? styles["button-outlined"] 
    : styles["button-normal"];

  const customStyle = {
    '--btn-bg': backgroundColor,
    '--btn-text': textColor,
  };

  return (
    <RadixButton
      ref={ref}
      className={`${styles.button} ${variantClass} ${className}`}
      size={size}
      onClick={onClick}
      style={customStyle}
      {...props}
    >
      {children}
    </RadixButton>
  );
});

Button.displayName = "Button";

export default Button;
